// 576054706193-7bf4rr04ci9ppofk5okmv6cgujcd4ima.apps.googleusercontent.com
//Client Secret
// mehZdDqigjLLUghY8GRD8yg9

// 576054706193-3d9vvt567sq6npl6u1h7vk1697tbjmag.apps.googleusercontent.com
// lc4ECqtRFPg3PvKhV4MGDcxD

/* <SocialButton
            provider="google"
            appId="576054706193-3d9vvt567sq6npl6u1h7vk1697tbjmag.apps.googleusercontent.com"
            onLoginSuccess={handleSocialLogin}
            onLoginFailure={handleSocialLoginFailure}
        >
            Login with Google
        </SocialButton> */

import React from "react"
// import SocialLogin from "react-social-login"
import styled from "react-emotion"

import Input from "ui/components/Input"
import { Section } from "ui"
import { Container } from "ui"
import Card from "ui/components/Card"
import Button from "ui/components/Button"
import Text from "ui/components/Text"

import { ContentWrapper, Content } from "../studio/ui/Layout"
import { LoginApi } from "./utils"
import { withRouter } from "react-router"
import { Helmet } from "react-helmet"


class LoginPage extends React.Component {
    state = {}

    render() {
        window.Intercom("boot", {
            app_id: (window.location.hostname === "studio.stacker.app" ? "txwvzciy" : "bu5482h5"),
            //Logged out user so may not have any user related info
        })

        return (
            <React.Fragment>
                <Helmet>
                    <link rel="shortcut icon" href="/favicon.clear.png" type="image/png" />
                    <meta charSet="utf-8" />
                    <title>Stacker Studio</title>
                </Helmet>
                <ContentWrapper>
                    <Content>
                        <LoginPanel>
                            <Logo
                                src="/static/media/stacker-logo.32813f5d.png"
                                alt="Stacker Logo"
                                style={{ marginBottom: 48, marginTop: 48 }}
                            />
                            <Section margin="small" padding="none">
                                <LoginInput
                                    onChange={e => this.setState({ email: e.target.value })}
                                    padding="medium"
                                    placeholder="Email"
                                />
                            </Section>

                            <Section margin="small" padding="none">
                                <LoginInput
                                    type="password"
                                    onChange={e => this.setState({ password: e.target.value })}
                                    padding="medium"
                                    placeholder="Password"
                                />
                            </Section>
                            <Container margin="none">
                                <LoginButton onClick={this.login} margin="medium" color="success">
                                    Log in
                            </LoginButton>
                            </Container>

                            <Container>
                                <Text style={{ color: "red" }}>
                                    &nbsp;{" "}
                                    {this.state.error && "Please check your username and password"}
                                </Text>
                            </Container>
                        </LoginPanel>
                    </Content>
                </ContentWrapper>
            </React.Fragment>
        )
    }

    login = () => {
        LoginApi.login(this.state.email, this.state.password).then(response => {
            let token = response.api_token
            if (!token) {
                this.setState({ error: true })
                return
            }
            window.intercomSettings = {
                app_id: (window.location.hostname === "studio.stacker.app" ? "txwvzciy" : "bu5482h5"),
                email: this.state.email, // Email address
            }

            window.Intercom("boot", window.intercomSettings)

            localStorage.setItem("studio_token", token)
            localStorage.setItem("user", JSON.stringify(response))
            this.props.router.push("/")
        })
    }
}

export default withRouter(LoginPage)

const LoginButton = styled(Button)`
    width: 300px;
    max-width: 70vw;
`

const LoginInput = styled(Input)`
    width: 300px;
    max-width: 70vw;
`

const LoginPanel = styled(Card)`
    width: 100%;
    max-width: 800px;
    height: 600px;
    text-align: center;
    margin: 10% auto;
    padding: 10%;
    align-items: center;
`

const Logo = styled("img")`
    width: 100%;
    max-width: 300px;
    display: block;
    margin: 0px auto ${props => props.theme.xlarge};
`

// const SocialButton = SocialLogin(({ children, triggerLogin, ...props }) => (
//     <button onClick={triggerLogin} {...props}>
//         {children}
//     </button>
// ))

// const handleSocialLogin = user => {
//     console.log(user)
// }

// const handleSocialLoginFailure = err => {
//     console.error(err)
// }



// WEBPACK FOOTER //
// ./src/features/auth/LoginPage.js